module.exports = __webpack_public_path__ + "img/goods16-4.0b985401.jpg";